/* tslint:disable */
/* eslint-disable */

/**
 * deliveryProviderPortal delivery-campaign-provider api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */

import { GeneratedApiClient, type GeneratedHttpClientConstraints, type RequestOptionsConstraint, HttpMethod, AuthStrategy, ShardingStrategy } from "../runtime";

import type {
    BulkSignUpSmartPromotionRequest,
    BulkSignUpSmartPromotionResponse,
    CancelPromotionRegistrationRequest,
    CancelSmartPromotionsRequest,
    CityExclusionTagsResponse,
    DiscardConflictingPromotionsRequest,
    GetAssignedPromotionsRequest,
    GetAssignedPromotionsResponse,
    GetAvailablePromotionsOptionsTreeRequest,
    GetAvailablePromotionsOptionsTreeResponse,
    GetBulkSmartPromotionSignupStatusRequest,
    GetBulkSmartPromotionSignupStatusResponse,
    GetCityExclusionTagsRequest,
    GetConflictingSelfServicePromotionsRequest,
    GetConflictingSelfServicePromotionsResponse,
    GetPromotionBannersRequest,
    GetPromotionBannersResponse,
    GetPromotionDetailsRequest,
    GetPromotionDetailsResponse,
    GetPromotionHistoryRequest,
    GetPromotionHistoryResponse,
    GetPromotionsPermissionsRequest,
    GetPromotionsPermissionsResponse,
    GetProviderEligibilityDataRequest,
    GetSelfServiceCampaignMetaRequest,
    GetSelfServiceCampaignMetaResponse,
    GetSmartPromotionDetailRequest,
    GetSmartPromotionDetailResponse,
    GetSmartPromotionEligibilityForProvidersRequest,
    GetSmartPromotionEligibilityForProvidersResponse,
    GetSmartPromotionLogsRequest,
    GetSmartPromotionLogsResponse,
    GetSmartPromotionOfferRequest,
    GetSmartPromotionOfferResponse,
    ProviderPortalEligibilityDataResponse,
    SignUpPromotionRequest,
    SignUpPromotionResponse,
    SignUpSmartPromotionRequest,
    SmartPromotionSignUpResponse,
    StoreAnalyticsEventRequest,
    UpdateMenuItemsForPromotionRequest,
    UpdateMenuItemsForPromotionResponse,
    StandardRequest,
} from '../models/index';

export interface HttpClientConstraints {
    Auth: AuthStrategy.JWT;
    Sharding: ShardingStrategy.NONE;
    StandardRequest: StandardRequest;
}



class ApiClientClass<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> extends GeneratedApiClient<THttpClientConstraints, TRequestOptions> {
        public bulkSignUpSmartPromotion = async (body: BulkSignUpSmartPromotionRequest, opts?: TRequestOptions): Promise<BulkSignUpSmartPromotionResponse>  => {
            return this.httpClient.sendRequest<BulkSignUpSmartPromotionResponse>({
                path: '/deliveryProviderPortal/bulkSignUpSmartPromotion',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public cancelPromotionRegistration = async (body: CancelPromotionRegistrationRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/cancelPromotionRegistration',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public cancelSmartPromotions = async (body: CancelSmartPromotionsRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/cancelSmartPromotions',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public discardConflictingPromotions = async (body: DiscardConflictingPromotionsRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/discardConflictingPromotions',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getAssignedPromotions = async (body: GetAssignedPromotionsRequest, opts?: TRequestOptions): Promise<GetAssignedPromotionsResponse>  => {
            return this.httpClient.sendRequest<GetAssignedPromotionsResponse>({
                path: '/deliveryProviderPortal/getAssignedPromotions',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getAvailablePromotionsOptionsTree = async (body: GetAvailablePromotionsOptionsTreeRequest, opts?: TRequestOptions): Promise<GetAvailablePromotionsOptionsTreeResponse>  => {
            return this.httpClient.sendRequest<GetAvailablePromotionsOptionsTreeResponse>({
                path: '/deliveryProviderPortal/getAvailablePromotionsOptionsTree',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getBulkSmartPromotionSignupStatus = async (body: GetBulkSmartPromotionSignupStatusRequest, opts?: TRequestOptions): Promise<GetBulkSmartPromotionSignupStatusResponse>  => {
            return this.httpClient.sendRequest<GetBulkSmartPromotionSignupStatusResponse>({
                path: '/deliveryProviderPortal/getBulkSmartPromotionSignupStatus',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getCityExclusionTags = async (body: GetCityExclusionTagsRequest, opts?: TRequestOptions): Promise<CityExclusionTagsResponse>  => {
            return this.httpClient.sendRequest<CityExclusionTagsResponse>({
                path: '/deliveryProviderPortal/getCityExclusionTags',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getConflictingSelfServicePromotions = async (body: GetConflictingSelfServicePromotionsRequest, opts?: TRequestOptions): Promise<GetConflictingSelfServicePromotionsResponse>  => {
            return this.httpClient.sendRequest<GetConflictingSelfServicePromotionsResponse>({
                path: '/deliveryProviderPortal/getConflictingSelfServicePromotions',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getPromotionBanners = async (body: GetPromotionBannersRequest, opts?: TRequestOptions): Promise<GetPromotionBannersResponse>  => {
            return this.httpClient.sendRequest<GetPromotionBannersResponse>({
                path: '/deliveryProviderPortal/getPromotionBanners',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getPromotionDetails = async (body: GetPromotionDetailsRequest, opts?: TRequestOptions): Promise<GetPromotionDetailsResponse>  => {
            return this.httpClient.sendRequest<GetPromotionDetailsResponse>({
                path: '/deliveryProviderPortal/getPromotionDetails',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getPromotionsHistory = async (body: GetPromotionHistoryRequest, opts?: TRequestOptions): Promise<GetPromotionHistoryResponse>  => {
            return this.httpClient.sendRequest<GetPromotionHistoryResponse>({
                path: '/deliveryProviderPortal/getPromotionsHistory',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getPromotionsPermissions = async (body: GetPromotionsPermissionsRequest, opts?: TRequestOptions): Promise<GetPromotionsPermissionsResponse>  => {
            return this.httpClient.sendRequest<GetPromotionsPermissionsResponse>({
                path: '/deliveryProviderPortal/getPromotionsPermissions',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getProviderEligibilityData = async (body: GetProviderEligibilityDataRequest, opts?: TRequestOptions): Promise<ProviderPortalEligibilityDataResponse>  => {
            return this.httpClient.sendRequest<ProviderPortalEligibilityDataResponse>({
                path: '/deliveryProviderPortal/getProviderEligibilityData',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getSelfServiceCampaignMeta = async (body: GetSelfServiceCampaignMetaRequest, opts?: TRequestOptions): Promise<GetSelfServiceCampaignMetaResponse>  => {
            return this.httpClient.sendRequest<GetSelfServiceCampaignMetaResponse>({
                path: '/deliveryProviderPortal/getSelfServiceCampaignMeta',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getSmartOffers = async (body: GetSmartPromotionOfferRequest, opts?: TRequestOptions): Promise<GetSmartPromotionOfferResponse>  => {
            return this.httpClient.sendRequest<GetSmartPromotionOfferResponse>({
                path: '/deliveryProviderPortal/getSmartOffers',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getSmartPromotionDetails = async (body: GetSmartPromotionDetailRequest, opts?: TRequestOptions): Promise<GetSmartPromotionDetailResponse>  => {
            return this.httpClient.sendRequest<GetSmartPromotionDetailResponse>({
                path: '/deliveryProviderPortal/getSmartPromotionDetails',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getSmartPromotionEligibilityForProviders = async (body: GetSmartPromotionEligibilityForProvidersRequest, opts?: TRequestOptions): Promise<GetSmartPromotionEligibilityForProvidersResponse>  => {
            return this.httpClient.sendRequest<GetSmartPromotionEligibilityForProvidersResponse>({
                path: '/deliveryProviderPortal/getSmartPromotionEligibilityForProviders',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public getSmartPromotionLogs = async (body: GetSmartPromotionLogsRequest, opts?: TRequestOptions): Promise<GetSmartPromotionLogsResponse>  => {
            return this.httpClient.sendRequest<GetSmartPromotionLogsResponse>({
                path: '/deliveryProviderPortal/getSmartPromotionLogs',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public signUpPromotion = async (body: SignUpPromotionRequest, opts?: TRequestOptions): Promise<SignUpPromotionResponse>  => {
            return this.httpClient.sendRequest<SignUpPromotionResponse>({
                path: '/deliveryProviderPortal/signUpPromotion',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public signUpSmartPromotion = async (body: SignUpSmartPromotionRequest, opts?: TRequestOptions): Promise<SmartPromotionSignUpResponse>  => {
            return this.httpClient.sendRequest<SmartPromotionSignUpResponse>({
                path: '/deliveryProviderPortal/signUpSmartPromotion',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public storeAnalyticsEvent = async (body: StoreAnalyticsEventRequest, opts?: TRequestOptions): Promise<void>  => {
            return this.httpClient.sendRequest<void>({
                path: '/deliveryProviderPortal/storeAnalyticsEvent',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
        public updateMenuItemsForPromotion = async (body: UpdateMenuItemsForPromotionRequest, opts?: TRequestOptions): Promise<UpdateMenuItemsForPromotionResponse>  => {
            return this.httpClient.sendRequest<UpdateMenuItemsForPromotionResponse>({
                path: '/deliveryProviderPortal/updateMenuItemsForPromotion',
                service_id: 'delivery-campaign-provider',
                subdomain: 'deliveryproviderportal',
                http_method: HttpMethod.POST,
                meta: {
                    auth: { enabled: true, strategy: AuthStrategy.JWT },
                    sharding: { enabled: false },
                    virtualPaths: { enabled: this.apiClientOptions?.virtualPathsEnabled ?? true }
                },
                body,
            }, opts);
        }
}
// Split class actual prototype and type
export const ApiClient = ApiClientClass;
/**
 * When you use ApiClient class as a type it would include private / protected properties which leads
 * to a situation where 2 sources of the ApiClient are not equal.
 *
 * This situation can happen for example when a library depends on the whole ApiClient and consumer wants to pass
 * in its own ApiClient. That would lead to an error
 *
 * TS2345: Argument of type 'ApiClient<HttpClientConstraints, HttpRequestOpts>' is not assignable to parameter of type 'ApiClient<HttpClientConstraints, never>'.
 *  Property 'apiClientOptions' is protected but type 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>' is not a class derived from 'GeneratedApiClient<THttpClientConstraints, TRequestOptions>'.
 */
export type ApiClient<THttpClientConstraints extends GeneratedHttpClientConstraints = HttpClientConstraints, TRequestOptions extends RequestOptionsConstraint = never> = {
    [Key in keyof ApiClientClass<THttpClientConstraints, TRequestOptions>]: ApiClientClass<THttpClientConstraints, TRequestOptions>[Key];
};
